<template>
    <div class="content">
        <div class="numBox">
            <div class="item">
                <div class="num"><span>{{ gqtzData.funds }}</span>支</div>
                <div class="tit">在管基金</div>
            </div>
            <div class="item">
                <div class="num"><span>{{ gqtzData.projects }}</span>个</div>
                <div class="tit">投资项目</div>
            </div>
            <div class="item">
                <div class="num"><span>{{ gqtzData.listedCompany }}</span>家</div>
                <div class="tit">上市公司</div>
            </div>
        </div>
        <div class="info" v-html="gqtzData.sketch">
        </div>
    </div>
</template>
  
<script>
export default {
    name: "partner",
    data() {
        return {
            gqtzData: {},
            pageInfo: {
                pageSize: 10,
                pageNum: 1,
                pageTotal: 2,
            },
        }
    },
    created() {
        this.getBusinessData();
    },
    methods: {
        getBusinessData() {
            this.$api.getBusinessList({
                classify: 1,
                ...this.pageInfo
            }).then(res => {
                this.gqtzData = res.rows[0]
            })
        },
    }
};
</script>
  
<style scoped lang="less">
.content {
    min-width: 93.75rem;
    padding: 50px 6.5rem;
    width: 93.75rem;
    margin: 0 auto;
    padding-top: 170px;
}

.numBox {
    display: flex;
    align-items: center;
    justify-content: space-around;

    .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #000;
        font-weight: bold;

        .num {
            font-size: 22px;

            span {
                font-size: 72px;
                margin-right: 5px;
            }
        }

        .tit {
            font-size: 16px;
            margin-top: 8px;
        }
    }
}

.info {
    font-size: 16px;
    font-family: "Microsoft YaHei";
    line-height: 32px;
    padding-left: 10px;
    margin-top: 50px;
}
</style>
  